// extracted by mini-css-extract-plugin
export default {"reader":"reader_reader__3pahk"};